import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/theme/legacy-dark.css'
import './styles/theme/palette.css'
import { AppErrorBoundary } from './components/AppErrorBoundary'
import { AppSkeleton } from '@/components/ui/AppSkeleton'

// Pre-render diagnostics and cache/SW cleanup
if (typeof window !== 'undefined') {
  try {
    const hook = (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__;
    const rendererCount = hook?.renderers ? hook.renderers.size : undefined;
    console.info('[Diag] React version:', React.version);
    if (rendererCount != null) {
      console.info('[Diag] React renderers:', rendererCount);
      if (rendererCount > 1) {
        console.error('⚠️ Multiple React renderers detected - potential cause of #310');
      }
    }
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((r) => r.unregister());
      });
    }
    if ('caches' in window) {
      caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
    }
  } catch (e) {
    console.warn('[Diag] Pre-render cleanup failed:', e);
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <Suspense fallback={<AppSkeleton />}>
        <App />
      </Suspense>
    </AppErrorBoundary>
  </React.StrictMode>,
)
